import {AlertType, PosthogEventPropertyValues} from './types';


export class AlertUtils {
  public static alertTypeToPosthogProperty(type: AlertType | null): string | null {
    switch (type) {
      case AlertType.SPIKE:
        return PosthogEventPropertyValues.ACTIVITY_SPIKE;
      case AlertType.DROP:
        return PosthogEventPropertyValues.ACTIVITY_DROP;
      default:
        return null;
    }
  }
}
